import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import type { PortalThemeVariables } from "@/interfaces/Configuration/ConfigurationFileContents";

const defaultThemeColors = {
  primary: "#1867c0",
  secondary: "#999999",
  accent: "#ecaf3d",
  error: "#f44336",
  info: "#2196f3",
  success: "#00c853",
};

function normalizePortalThemeVariables(variablesObject: PortalThemeVariables = {}) {
  return Object.entries(variablesObject).reduce<Record<string, string>>(
    (accumulator, [key, value]) => {
      if (value) {
        accumulator[key.toLowerCase()] = value;
      }

      return accumulator;
    },
    {}
  );
}

export default function createPortalVuetify(
  variablesObject: PortalThemeVariables = {}
) {
  return createVuetify({
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          dark: false,
          colors: {
            ...defaultThemeColors,
            ...normalizePortalThemeVariables(variablesObject),
          },
        },
      },
    },
  });
}
